// https://stackoverflow.com/questions/30439694/converting-jquerys-css-timing-to-ms
export function cssTimeToMilliseconds(s) {
  return parseFloat(s) * (/\ds$/.test(s) ? 1000 : 1);
}
